/* eslint-disable no-eval */
import moment from "moment";

class DateUtil {
  static dateAnsi(date: Date = new Date()): string {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).padStart(4, "0");

    return `${year}-${month}-${day}`;
  }

  static dateTimeAnsi(date: Date = new Date()): string {
    let dateTimeAnsi = this.dateAnsi(date);

    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
    const second = String(date.getSeconds()).padStart(2, "0");

    dateTimeAnsi += ` ${hour}:${minute}:${second}`;

    return dateTimeAnsi;
  }

  static nowDate(local: boolean = false): Date {
    if (local) {
      const nowlocal = new Date().toLocaleString();
      return new Date(
        parseInt(String(nowlocal).substring(6, 4)),
        parseInt(String(nowlocal).substring(3, 2)) - 1,
        parseInt(String(nowlocal).substring(0, 2)),
        parseInt(String(nowlocal).substring(11, 2)),
        parseInt(String(nowlocal).substring(14, 2)),
        parseInt(String(nowlocal).substring(17, 2))
      );
    }

    return new Date();
  }

  static nowToString(
    type: "local" | "ISO" | "UTC" = "local",
    full: boolean = true
  ): string {
    const now: Date = DateUtil.nowDate();
    switch (type) {
      case "ISO":
        return now.toISOString();
    }
    return full ? now.toLocaleDateString() : now.toLocaleDateString();
  }

  static nowTimeString(
    type: "local" | "UTC" | "GMT" = "local",
    full: boolean = false
  ): string {
    const now = DateUtil.nowDate();
    switch (type) {
      case "UTC":
      case "GMT":
        return `${now.getHours()}:${now
          .getMinutes()
          .toString()
          .padStart(2, "0")}${full ? ":" + now.getDay().toString().padStart(2, "0") : ""
          }`;
    }

    return full
      ? now.toLocaleTimeString()
      : now.toLocaleTimeString().substr(0, 5);
  }

  static isBefore(initialDate: Date, finalDate: Date, comparison: ">" | ">=" = ">"): boolean {
    return eval(`_initialDate ${comparison} _finalDate`);
  }

  static isAfter(initialDate: Date, finalDate: Date, comparison: "<" | "<=" = "<"): boolean {
    return eval(`_initialDate ${comparison} _finalDate`);
  }

  static isBetween(initialDate: Date, finalDate: Date): boolean {
    const _initialDate = initialDate.getMilliseconds();
    const _finalDate = finalDate.getMilliseconds();

    return _initialDate >= _finalDate && _initialDate <= _finalDate;
  }

  static dateFormat(date: Date | string, format: string): string {
    const mDate = moment(date);

    return mDate.format(format);
  }

  static firstMonth(data: Date = new Date()): Date {
    return new Date(data.getFullYear(), data.getMonth(), 1);
  }

  static lastMonth(data: Date = new Date()): Date {
    let dataLocal = this.incMonth(data);
    dataLocal.setDate(this.firstMonth(dataLocal).getDate() - 1);
    return dataLocal;
  }

  static incMonth(data: Date = new Date(), value: number = 1): Date {
    const dataCustom = new Date(data);
    return new Date(dataCustom.setMonth(dataCustom.getMonth() + value));
  }

  static decMonth(data: Date = new Date(), value: number = 1): Date {
    const dataCustom = new Date(data);
    return new Date(dataCustom.setMonth(dataCustom.getMonth() - value));
  }

  static diffDays(dataInicial: Date, dataFinal: Date = new Date()): number {
    const diff = Math.abs(dataFinal.getTime() - dataInicial.getTime());
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  }

  static stringToDate = (date: string | undefined | null, inFormat?: string): Date | null => {
    let _format = inFormat || "YYYY-MM-DD hh:mm:ss"
    if (date) {
      const _mDate = moment(date, _format)
      return _mDate.isValid() ? _mDate.toDate() : null
    }

    return null;
  }
}

export { DateUtil };
